export default "__VITE_ASSET__DaVl_WQN__"